import { BeckyTopology } from '../../types/becky'

export const whitelistedEndpoints = [
	'https://sled.wix.dev/',
	'https://bo.wix.com/suricate/tunnel/',
	'https://localhost:',
	'http://localhost:',
]

export const getEditorElementsAssetUrl = (url: string, { fileRepoUrl }: BeckyTopology): string => {
	const scriptsUrlNoTrailingSlash = fileRepoUrl.replace(/(.*)\/$/, '$1')
	return whitelistedEndpoints.some((endpoint) => url.startsWith(endpoint))
		? url
		: `${scriptsUrlNoTrailingSlash}/services/editor-elements/dist/${url}`
}
